import { RouterStore } from '@estee/elc-router';

import { IUserState } from '~api/RampPgApiSdk';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { UserRepository } from '~repositories/UserRepository';
import { QRCODE_ROUTE } from '~routes/routes';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';

import { LoginSubmittedUseCase } from './LoginSubmittedUseCase';

interface ISignUpSuccessUseCase {
    user: IUserState;
    posFrontiersErrorKey?: string;
    posIKalarCallbackUrl?: string;
    isMobileOnlyRegistration?: boolean;
}

export class SignUpSuccessUseCase {
    private user: IUserState;
    private posFrontiersErrorKey?: string;
    private posIKalarCallbackUrl?: string;
    private isMobileOnlyRegistration: boolean;

    private userRepository: UserRepository;
    private routerStore: RouterStore;
    private configRepository: ConfigRepository;

    constructor({
        user,
        posFrontiersErrorKey,
        posIKalarCallbackUrl,
        isMobileOnlyRegistration
    }: ISignUpSuccessUseCase) {
        this.user = user;
        this.posFrontiersErrorKey = posFrontiersErrorKey;
        this.posIKalarCallbackUrl = posIKalarCallbackUrl;
        this.isMobileOnlyRegistration = !!isMobileOnlyRegistration;
        this.routerStore = diContainer.get(serviceNames.routerStore);
        this.userRepository = diContainer.get(serviceNames.userRepository);
        this.configRepository = diContainer.get(serviceNames.configRepository);
    }

    public execute = async () => {
        const {
            userFormStore: { clearStore, values },
            setUserId,
            setIsMobileOnlyRegistration,
            setRegisteredUser,
            setPosFrontierError,
            setPosIKalarCallbackUrl,
            populateOnlineSignUpFormStore
        } = this.userRepository;
        const {
            journey: { loginOnSuccess, postSubmitRoute },
            emailIdentifierFieldName
        } = this.configRepository;

        if (loginOnSuccess && emailIdentifierFieldName) {
            const accountIdentifier = values[emailIdentifierFieldName] ?? '';
            const password = values.password ?? '';
            await new LoginSubmittedUseCase({
                signInData: { accountIdentifier, password },
                emitTrackingEvent: false,
                isSignInAfterSignUp: true
            }).execute();
        } else {
            const { userId } = this.user;
            this.posFrontiersErrorKey && setPosFrontierError(this.posFrontiersErrorKey);
            this.posIKalarCallbackUrl && setPosIKalarCallbackUrl(this.posIKalarCallbackUrl);
            setUserId(userId);
            setIsMobileOnlyRegistration(this.isMobileOnlyRegistration);
            setRegisteredUser(this.user);
            if (postSubmitRoute === QRCODE_ROUTE) {
                populateOnlineSignUpFormStore();
                clearStore();
            }
            this.routerStore.changeCurrentRoute(postSubmitRoute);
        }
    };
}
